import { render } from "./TopChannels.vue?vue&type=template&id=7310239f&ts=true"
import script from "./TopChannels.vue?vue&type=script&lang=ts"
export * from "./TopChannels.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__